"use strict";
export const ApplicationsMock = (mock) => {
  mock.onGet("/api/v1/apps/group").reply((config) => {
    let _response = {
      "model": "data.set",
      "datas": ["\u70ED\u95E8\u63A8\u8350", "\u65B0\u54C1\u63A8\u8350"],
      "total": 2
    };
    return [200, _response];
  });
  mock.onGet("/api/v1/apps").reply((config) => {
    console.log(config);
    let group_name = config.params.group_name || "";
    let is_all = config.params.is_all || "0";
    let _response = {
      "model": "data.set",
      "datas": [{}],
      "total": 0
    };
    if (group_name === "\u70ED\u95E8\u63A8\u8350") {
      _response = {
        "model": "data.set",
        "datas": [
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002",
            "is_service": "true"
          },
          {
            "model": "app.group.data",
            "id": "app_2",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
            "name": "PP\u4FDD\u9556",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_3",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNUnfz7PwAFTAK03W0EIwAAAABJRU5ErkJggg==",
            "name": "\u81EA\u52A8\u5316\u52A9\u624B",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          }
        ],
        "total": 3
      };
    }
    if (group_name === "\u65B0\u54C1\u63A8\u8350") {
      _response = {
        "model": "data.set",
        "datas": [
          {
            "model": "app.group.data",
            "id": "app_4",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
            "name": "\u8BBE\u5907\u6388\u6743",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_5",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
            "name": "\u4F01\u4E1A\u7F51\u76D8",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNUnfz7PwAFTAK03W0EIwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNUnfz7PwAFTAK03W0EIwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          }
        ],
        "total": 7
      };
    }
    if (is_all === "1") {
      _response = {
        "model": "data.set",
        "datas": [
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002",
            "is_service": "true"
          },
          {
            "model": "app.group.data",
            "id": "app_2",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
            "name": "PP\u4FDD\u9556",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_3",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNUnfz7PwAFTAK03W0EIwAAAABJRU5ErkJggg==",
            "name": "\u81EA\u52A8\u5316\u52A9\u624B",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_4",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
            "name": "\u8BBE\u5907\u6388\u6743",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_5",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
            "name": "\u4F01\u4E1A\u7F51\u76D8",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNUnfz7PwAFTAK03W0EIwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNUnfz7PwAFTAK03W0EIwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          },
          {
            "model": "app.group.data",
            "id": "app_1",
            "head_image": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
            "name": "\u5E97\u94FA\u62A5\u8868",
            "tags": [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }],
            "description": "\u767E\u5EA6\u7FFB\u8BD1\u5B98\u65B9\u51FA\u54C1\u3002\u652F\u630127\u79CD\u8BED\u8A00\u7684\u7FFB\u8BD1,\u6D4F\u89C8\u5916\u6587\u7F51\u9875\u65F6\u53EF\u4E00\u952E\u7F51\u9875\u7FFB\u8BC4",
            "is_service": "false"
          }
        ],
        "total": 7
      };
    }
    return [200, _response];
  });
  mock.onGet(/\/api\/v1\/apps\/app_\w+/).reply((config) => {
    let url = config.url || "";
    let _id = url.split("/")[url.split("/").length - 1];
    console.log(_id);
    const content = `<p>\u6838\u5FC3\u529F\u80FD\u5982\u4E0B</p>
        <p>\u5173\u952E\u8BCD\u53CD\u67E5:\u53CD\u67E5\u4E9A\u9A6C\u900A\u7ADF\u54C1\u6838\u5FC3\u6D41\u5448\u8BCD,\u65B9\u4FBF\u60A8\u4F18\u5316 Listing\u548CPPC\u5E7F\u544A</p>
        <p>\u5173\u952E\u8BCD\u6316\u6398:\u63A8\u8350\u6700\u6709\u4EF7\u503C\u7684\u4E9A\u9A6C\u900A\u76F8\u5173\u5173\u952E\u8BCD,\u662F\u60A8 Listing\u4F18\u5316\u3001PPC\u5E7F\u544A\u5173\u952E\u8BCD\u5F15\u64CE</p>
        <p>\u4EA7\u54C1\u67E5\u8BE2:\u901A\u8FC7\u5927\u6570\u636E\u667A\u80FD\u7B97\u6CD5\u7CBE\u51C6\u9884\u6D4B Amazon Listing\u5F53\u524D\u53CA\u6700\u8FD13\u5E74\u7684\u6708\u9500\u91CF\u3002\u8FFD\u6EAF\u4EA7\u54C1\u81EA</p>
        <p>\u4E0A\u67B6\u4EE5\u6765\u7684\u4EF7\u683C\u3001BSR\u3001\u8BC4\u8BBA\u6570\u548C\u8BC4\u5206\u503C,\u4EE5\u53CA\u8DDF\u5356\u3001\u4FC3\u9500\u6D3B\u52A8\u4FE1\u606F</p>
        <p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88/bDfwAJYAPKxXWN5gAAAABJRU5ErkJggg==" style="width:100%;height:500px;"></p>`;
    let _response = {
      model: "operation",
      result: {
        model: "apps.info",
        name: "\u9ED8\u8BA4\u5E94\u7528",
        description: "\u5E97\u94FA\u62A5\u8868\u81EA\u52A8\u5316\u5DE5\u5177\uFF0C\u5E2E\u52A9\u8DE8\u5883\u5356\u5BB6\u4FBF\u6377\u83B7\u53D6\u4E9A\u9A6C\u900AeBay\u901F\u5356\u901ALazada\u7B49\u5E73\u53F0\uFF1B\u5E97\u94FA\u62A5\u8868\u81EA\u52A8\u5316\u5DE5\u5177\uFF0C\u5E2E\u52A9\u8DE8\u5883\u5356\u5BB6\u4FBF\u6377\u83B7\u53D6\u4E9A\u9A6C\u900AeBay\u901F\u5356\u901ALazada\u7B49\u5E73\u53F0\uFF1B\u5E97\u94FA\u62A5\u8868\u81EA\u52A8\u5316\u5DE5\u5177\uFF0C\u5E2E\u52A9\u8DE8\u5883\u5356\u5BB6\u4FBF\u6377\u83B7\u53D6\u4E9A\u9A6C\u900AeBay\u901F\u5356\u901ALazada\u7B49\u5E73\u53F0",
        details_introduce: content,
        user_count: "16",
        app_version: "2.7.5",
        updated_time: "2021\u5E742\u670828\u65E5",
        lang: "English\uFF0C\u4E2D\u6587(\u7B80\u4F53)",
        is_service: "true",
        provider: "\u8DE8\u5883\u536B\u58EB",
        tags: [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }]
      },
      message: "success"
    };
    if (_id === "app_1") {
      _response.result.name = "\u5E97\u94FA\u62A5\u8868";
      _response.result.tags = [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }];
    }
    if (_id === "app_2") {
      _response.result.name = "PP\u4FDD\u9556";
      _response.result.is_service = "false";
      _response.result.tags = [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }];
    }
    if (_id === "app_3") {
      _response.result.name = "\u81EA\u52A8\u5316\u52A9\u624B";
      _response.result.is_service = "false";
      _response.result.tags = [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }];
    }
    if (_id === "app_4") {
      _response.result.name = "\u8BBE\u5907\u6388\u6743";
      _response.result.is_service = "false";
      _response.result.tags = [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }];
    }
    if (_id === "app_5") {
      _response.result.name = "\u4F01\u4E1A\u7F51\u76D8";
      _response.result.is_service = "false";
      _response.result.tags = [{ "tag": "\u5B98\u65B9", "color": "green" }, { "tag": "\u9650\u65F6\u514D\u8D39", "color": "red" }, { "tag": "\u65B0\u54C1", "color": "red" }];
    }
    return [200, _response];
  });
  mock.onGet("/api/v1/account/apps").reply((config) => {
    let _response = {
      model: "data.set",
      datas: [
        {
          model: "app.account.service",
          id: "app_1",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
          name: "\u5E97\u94FA\u62A5\u8868"
        },
        {
          model: "app.account.service",
          id: "app_2",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
          name: "PP\u4FDD\u9556"
        },
        {
          model: "app.account.service",
          id: "app_3",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNUnfz7PwAFTAK03W0EIwAAAABJRU5ErkJggg==",
          name: "\u81EA\u52A8\u5316\u52A9\u624B"
        },
        {
          model: "app.account.service",
          id: "app_4",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8H9LwHwAHAQLUWe/wJwAAAABJRU5ErkJggg==",
          name: "\u8BBE\u5907\u6388\u6743"
        },
        {
          model: "app.account.service",
          id: "app_5",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
          name: "\u4F01\u4E1A\u7F51\u76D8"
        },
        {
          model: "app.account.service",
          id: "app_1",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
          name: "\u5E97\u94FA\u62A5\u8868"
        },
        {
          model: "app.account.service",
          id: "app_1",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNUnfz7PwAFTAK03W0EIwAAAABJRU5ErkJggg==",
          name: "\u5E97\u94FA\u62A5\u8868"
        },
        {
          model: "app.account.service",
          id: "app_1",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8H9LwHwAHAQLUWe/wJwAAAABJRU5ErkJggg==",
          name: "\u5E97\u94FA\u62A5\u8868"
        },
        {
          model: "app.account.service",
          id: "app_1",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNU3Nv7HwAE3gJsLrgsAwAAAABJRU5ErkJggg==",
          name: "\u5E97\u94FA\u62A5\u8868"
        },
        {
          model: "app.account.service",
          id: "app_1",
          head_image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8PU/1PwAHGQK/3KybqwAAAABJRU5ErkJggg==",
          name: "\u5E97\u94FA\u62A5\u8868"
        }
      ],
      total: 10
    };
    return [200, _response];
  });
  mock.onGet("/api/v1/apps/users").reply((config) => {
    let _response = {
      "model": "operation",
      "message": "success",
      "result": {
        "all_user": [
          {
            "name": "chenyi",
            "guid": "user_5279465ea18049f888f752bb2b5b82a4",
            "account": "150222970070155",
            "model": "sub_account"
          },
          {
            "name": "\u8C46\u8C46",
            "guid": "user_b69e87b6c4e2435fb750d38e5735ccf5",
            "account": "150222970070154",
            "model": "sub_account"
          },
          {
            "name": "\u8D75\u521A\u65B0\u53F7",
            "guid": "user_d31b7ae215db46d1b2ddeb57679f691a",
            "account": "150222970070150",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5149",
            "guid": "user_144a6d84e4ca4525a8976316ea42950c",
            "account": "150222970070149",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5148",
            "guid": "user_22cb1683b0cb4c2c9876442c63befef2",
            "account": "150222970070148",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5147",
            "guid": "user_d0f88f486ef441c19d4d857e22bdfd57",
            "account": "150222970070147",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5146",
            "guid": "user_853f74fed3264a06b81f6ae9c540b230",
            "account": "150222970070146",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5145",
            "guid": "user_d1e9537550804e8cb605d3a6db9282cd",
            "account": "150222970070145",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5144",
            "guid": "user_a5bda7096a4c4ae0b68d46cd0e8834b8",
            "account": "150222970070144",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5143",
            "guid": "user_d1d3140c22ce4094aee1594f2a5c9b13",
            "account": "150222970070143",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5142",
            "guid": "user_4e3d86d5af6c4efda66d5902105a47f1",
            "account": "150222970070142",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5141",
            "guid": "user_7b4c2f85f59a4ceaa554ec981930ce6e",
            "account": "150222970070141",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5140",
            "guid": "user_86f870cf560147a8a303050a49744c41",
            "account": "150222970070140",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5139",
            "guid": "user_185f183032204eff86978466c5ebf607",
            "account": "150222970070139",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5138",
            "guid": "user_6ebbbf9f9ca743d4afc8dd504c67c11e",
            "account": "150222970070138",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5137",
            "guid": "user_5609fb34f5bc4c508fd673f8a238c1d1",
            "account": "150222970070137",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5136",
            "guid": "user_47ef00e037d743a3a77dc669544021d0",
            "account": "150222970070136",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5135",
            "guid": "user_4fec0c25a6c24e2392bcc683a1dc62ea",
            "account": "150222970070135",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5134",
            "guid": "user_f36753a2f1da4de38740aae95f4d71b7",
            "account": "150222970070134",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5133",
            "guid": "user_1d649f315b18423f8e6754bd9da503b7",
            "account": "150222970070133",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5132",
            "guid": "user_77550733781b44548795c6acbc151737",
            "account": "150222970070132",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5131",
            "guid": "user_70ac0e0db80e472fa450b0bdcc2bc2fc",
            "account": "150222970070131",
            "model": "sub_account"
          },
          {
            "name": "\u5458\u5DE5130",
            "guid": "user_3df24fe4a53546d092aebd13c5c4b020",
            "account": "150222970070130",
            "model": "sub_account"
          },
          {
            "name": "\u6728\u5C9B\u4E3B",
            "guid": "user_92eda6d5a62742059805103822a84dbf",
            "account": "150222970070039",
            "model": "sub_account"
          },
          {
            "name": "\u6C64\u82E5\u671B",
            "guid": "user_7ccd4a64a8444864add232c5fb5cda30",
            "account": "150222970070038",
            "model": "sub_account"
          },
          {
            "name": "\u675C\u767E\u5F53",
            "guid": "user_4e1a0845066f40209bd9586749de260c",
            "account": "150222970070037",
            "model": "sub_account"
          },
          {
            "name": "\u82D7\u82E5\u5170",
            "guid": "user_9176cd409c8c4ccd9c832e189384616d",
            "account": "150222970070036",
            "model": "sub_account"
          },
          {
            "name": "\u6BB7\u4EF2\u7FD4",
            "guid": "user_2c50c565ab22483cb0ac96ff75d21e83",
            "account": "150222970070035",
            "model": "sub_account"
          },
          {
            "name": "\u5434\u5E94\u718A",
            "guid": "user_0263378e4d7b49059e024238b3a27624",
            "account": "150222970070034",
            "model": "sub_account"
          },
          {
            "name": "\u90B1\u5C71\u98CE",
            "guid": "user_be17bc5ae0d44c4b994a162d4e353a1c",
            "account": "150222970070033",
            "model": "sub_account"
          },
          {
            "name": "\u5F20\u5FD7\u5149",
            "guid": "user_4be576c0d4b54ca4b5efe62209360b07",
            "account": "150222970070032",
            "model": "sub_account"
          },
          {
            "name": "\u6768\u9E4F\u4E3E",
            "guid": "user_5d550eb33b504c018e9f30d4d366a8bc",
            "account": "150222970070031",
            "model": "sub_account"
          },
          {
            "name": "\u4EEA\u548C",
            "guid": "user_95325ebcb73548cd8832f3add1c2e2e4",
            "account": "150222970070030",
            "model": "sub_account"
          },
          {
            "name": "\u963F\u66FC",
            "guid": "user_9c045105b6af41b7bd98730b295553a2",
            "account": "150222970070029",
            "model": "sub_account"
          },
          {
            "name": "\u82CF\u4E60\u4E4B",
            "guid": "user_0df3e896d798476f80659ded5ca3aa6d",
            "account": "150222970070028",
            "model": "sub_account"
          },
          {
            "name": "\u5415\u5C0F\u59B9",
            "guid": "user_46b547d67578432099a4a576292c14fb",
            "account": "150222970070027",
            "model": "sub_account"
          },
          {
            "name": "\u745E\u680B",
            "guid": "user_f781e54cb9cc4467a451151eeeabd2b8",
            "account": "150222970070026",
            "model": "sub_account"
          },
          {
            "name": "\u5415\u5C0F\u59B9",
            "guid": "user_e11f6573ecb94667932078b9dcf14924",
            "account": "150222970070025",
            "model": "sub_account"
          },
          {
            "name": "\u51E4\u4E00\u9E23",
            "guid": "user_095c16ddf79f4512b206bcb19786e914",
            "account": "150222970070024",
            "model": "sub_account"
          },
          {
            "name": "\u9093\u70B3\u6625",
            "guid": "user_9514b13bfb424c7f84f85a7df7c5404e",
            "account": "150222970070023",
            "model": "sub_account"
          },
          {
            "name": "\u6C64\u7956\u5FB7",
            "guid": "user_33a674ee80eb4a09a234569a0beed417",
            "account": "150222970070022",
            "model": "sub_account"
          },
          {
            "name": "\u5468\u7EEE",
            "guid": "user_53af20280e4b4e64aff4f7e0179aae2e",
            "account": "150222970070021",
            "model": "sub_account"
          },
          {
            "name": "\u9EC4\u5E0C\u8282",
            "guid": "user_6776ddde46ce4aa98698f2abed1a619c",
            "account": "150222970070020",
            "model": "sub_account"
          },
          {
            "name": "\u90DD\u5927\u901A",
            "guid": "user_2b2f416f7d984783afc932a696b112fe",
            "account": "150222970070019",
            "model": "sub_account"
          },
          {
            "name": "\u5B8B\u4E94",
            "guid": "user_9016860a91ec408c9cec3ec44ec622bf",
            "account": "150222970070018",
            "model": "sub_account"
          },
          {
            "name": "\u97E9\u65E0\u57A2",
            "guid": "user_841a6d64adcd4479a804bcd4f62bf8f5",
            "account": "150222970070017",
            "model": "sub_account"
          },
          {
            "name": "\u674E\u529B\u4E16",
            "guid": "user_f76452212d23455681550f00678580e2",
            "account": "150222970070016",
            "model": "sub_account"
          },
          {
            "name": "\u9A6C\u6CD5\u901A",
            "guid": "user_3bbcc0893c164f97af6d8124fb68d37c",
            "account": "150222970070015",
            "model": "sub_account"
          },
          {
            "name": "\u5E38\u91D1\u9E4F",
            "guid": "user_9f1aad9280e540148a755a610274b4a0",
            "account": "150222970070014",
            "model": "sub_account"
          },
          {
            "name": "\u66F9\u80FD",
            "guid": "user_55901c49aac0405ca6a372d596431101",
            "account": "150222970070013",
            "model": "sub_account"
          },
          {
            "name": "\u70B9\u82CD\u6E14\u9690",
            "guid": "user_5815c9070c854182a6337e107a56a4cf",
            "account": "150222970070012",
            "model": "sub_account"
          },
          {
            "name": "\u67EF\u4E07\u94A7",
            "guid": "user_b64a8af268ca49ce884fe23a73f255c8",
            "account": "150222970070011",
            "model": "sub_account"
          },
          {
            "name": "\u9A6C\u5927\u9E23",
            "guid": "user_fa8df540ac2144319e7a75bb8a931769",
            "account": "150222970070010",
            "model": "sub_account"
          },
          {
            "name": "\u5B89\u5949\u65E5",
            "guid": "user_25934716f875498890be8d422a417a07",
            "account": "150222970070009",
            "model": "sub_account"
          },
          {
            "name": "\u5F20\u4FE1",
            "guid": "user_6c7d83b256134bc79ca4fd3d3c66835f",
            "account": "150222970070008",
            "model": "sub_account"
          },
          {
            "name": "\u51AF\u9521\u8303",
            "guid": "user_4001d8935a7b471186668e38717bce33",
            "account": "150222970070007",
            "model": "sub_account"
          },
          {
            "name": "\u80E1\u6842\u5357",
            "guid": "user_cb9cc9e55b3346518849d4fde51130c5",
            "account": "150222970070006",
            "model": "sub_account"
          },
          {
            "name": "\u674E\u83AB\u6101",
            "guid": "user_90d2161840d249b5974ec3313a9610c2",
            "account": "150222970070005",
            "model": "sub_account"
          },
          {
            "name": "\u5218\u7AF9\u5E84",
            "guid": "user_3b6c8852b30647409b3a8071370a2510",
            "account": "150222970070004",
            "model": "sub_account"
          },
          {
            "name": "\u5F90\u8FBE",
            "guid": "user_fd7bf2db54de45729e8df18f39027d80",
            "account": "150222970070003",
            "model": "sub_account"
          },
          {
            "name": "\u90ED\u8299",
            "guid": "user_27347f8995244672bcb91b921c5feb27",
            "account": "150222970070002",
            "model": "sub_account"
          },
          {
            "name": "\u97E6\u4E00\u7B11",
            "guid": "user_a03afeb1ea5b45f7abbaa71104bf5773",
            "account": "150222970070001",
            "model": "sub_account"
          },
          {
            "name": "\u5415\u6B63\u5E73",
            "guid": "user_87201be2f7364af180020c348b62d0ab",
            "account": "150222970070000",
            "model": "sub_account"
          }
        ],
        "authorization_user": [
          {
            "name": "\u8C46\u8C46",
            "guid": "user_b69e87b6c4e2435fb750d38e5735ccf5",
            "account": "150222970070154",
            "model": "sub_account"
          }
        ]
      }
    };
    return [200, _response];
  });
  mock.onGet("/api/v1/apps/check/account").reply((config) => {
    let _response = {
      "model": "operation",
      "message": "success",
      "result": 0
    };
    return [200, _response];
  });
};
